// Settings for viewport directive
export default {
	/*
	 * https://www.npmjs.com/package/vue-in-viewport-directive
	 * Use with classes from the _transitions.scss file
	 */
	data: function () {
		return {
			viewportTransitionOffsetTop: 0, // distance between top of element and bottom of screen when animation starts
			viewportTransitionOffsetBottom: -80 // distance between bottom of element and top of screen when animation starts
		};
	}
};
